import React from "react";
import Productpage from "../components/Productpage";

function Product() {
  return (
    <main className="min-h-screen bg-cream">
      <Productpage />
    </main>
  );
}

export default Product;
